import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Component that redirects routes with trailing slashes to the same route without the trailing slash.
 * This prevents 404 errors when browsers automatically add trailing slashes to URLs.
 */
export default function TrailingSlashRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // Check if pathname ends with a slash (but not the root "/")
    if (pathname !== "/" && pathname.endsWith("/")) {
      // Remove the trailing slash
      const newPathname = pathname.slice(0, -1);
      // Preserve query string and hash if they exist
      const newPath = newPathname + search + hash;
      
      // Replace the current URL without the trailing slash (no page reload)
      navigate(newPath, { replace: true });
    }
  }, [location, navigate]);

  return null; // This component doesn't render anything
}

